import React from 'react'
import {connect} from 'react-redux'
import {renderPopular} from '../../utils'


class MainLimitBar extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            show: false
        }
    }

    componentWillUnmount() {
        this.timeout && clearTimeout(this.timeout)
        this.timer && cancelAnimationFrame(this.timer)
    }

    componentDidMount() {
        let data = this.props.data
        let startTime = data.start_time,
            endTime = data.end_time,
            currentTime = parseInt(new Date().getTime() / 1000, 10)

        if (!startTime || data.contents.length === 0) {
            return
        }

        if (currentTime > startTime) {
            this.onTime(endTime)
        } else {
            this.timeout = setTimeout(() => {
                this.onTime(endTime)
            }, (startTime - currentTime) * 1000)
        }
    }

    onTime(endTime) {
        let getDuration = () => (endTime - parseInt(new Date().getTime() / 1000, 10))
        let getMs = () => 9 - parseInt(~~(new Date().getTime() / 1000).toString().split(".")[1] / 100, 10)
        this.setState({show: true})

        let _that = this
        this.timer = requestAnimationFrame(function fn() {
            let duration = getDuration()
            let ms = getMs()
            if (duration < 0) {
                _that.setState({show: false})
                cancelAnimationFrame(_that.timer)
            } else {
                _that.refs.limitMs.innerHTML = ms

                let tmp = duration
                let ss = tmp % 60
                _that.refs.limitSs.innerHTML = ss

                tmp = (tmp - ss) / 60
                let mm = tmp % 60
                _that.refs.limitMm.innerHTML = mm

                tmp = (tmp - mm) / 60
                let dd = (tmp - tmp % 24) / 24
                _that.refs.limitHh.innerHTML = tmp % 24 + dd * 24

                _that.timer = requestAnimationFrame(fn)
            }
        })
    }

    render() {
        if (!this.state.show) {
            return null
        }

        return (
            <div className="main-limit-bar">
                <div className="limit-bar-title">
                    <p className="limit-bar-title__main fl wk-clamp-line">{this.props.data.name}</p>
                    <span className="limit-bar-time fl">
                        <span className="limit-bar-time__num" ref="limitHh">0</span>
                        <span className="limit-bar-time__point">:</span>
                        <span className="limit-bar-time__num" ref="limitMm">0</span>
                        <span className="limit-bar-time__point">:</span>
                        <span className="limit-bar-time__num" ref="limitSs">0</span>
                        <span className="limit-bar-time__point">.</span>
                        <span className="limit-bar-time__num" ref="limitMs">0</span>
                    </span>
                </div>

                <div className="limit-bar-content">
                    {this.props.data.contents.map((item, index) =>
                        <div className="limit-bar-item" key={index} onClick={() => location.assign(item.obj_url)}>
                            <div className="limit-bar-item__image"
                                 style={{backgroundImage: `url(${item.cover_url})`}}>
                                <p className="limit-bar-item__name wk-clamp-line">{item.title}</p>
                            </div>
                            <div className="limit-bar-item__bottom">
                                <span className="limit-bar-item__fu">￥</span>
                                <span className="limit-bar-item__money">{item.price.toString().split('.').length > 0 && `${item.price.toString().split('.')[0]}`}</span>
                                <span className="limit-bar-item__point" style={{marginLeft: /WindowsWechat/.test(navigator.userAgent) ? "3px" : "0"}}>
                                    {item.price.toString().split('.').length > 1 && `.${item.price.toString().split('.')[1]}`}
                                </span>
                                <div className="limit-bar-item__bd">
                                    <span className="limit-bar-item__origin">原价：{item.real_money}</span>
                                    <span className="limit-bar-item__popular">{renderPopular(item.popular)}人抢</span>
                                </div>
                                <img className="limit-bar-item__icon"
                                     src='https://static-cos.lycheer.net/picture/7833117_8e4563360095bbea0f235f13907bbbe9.jpg-picmsg420'/>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

export default connect((state) => ({
    sex: state.account.sex
}))(MainLimitBar)



// WEBPACK FOOTER //
// ./src/components/main/MainLimitBar.js